import { createFileRoute } from "@tanstack/react-router";
import { VendorAiAssistantPage } from "@/components/vendor/ai-assistant/VendorAiAssistantPage";

export const Route = createFileRoute("/vendor/ai-assistant")({
  head: () => ({ meta: [{ title: "Pulse AI Assistant · Venue Portal" }] }),
  component: VendorAiAssistantPage,
});
